import { render, staticRenderFns } from "./PasswordCreator.vue?vue&type=template&id=a5965cfe&scoped=true&"
import script from "./PasswordCreator.vue?vue&type=script&lang=js&"
export * from "./PasswordCreator.vue?vue&type=script&lang=js&"
import style0 from "./PasswordCreator.vue?vue&type=style&index=0&id=a5965cfe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5965cfe",
  null
  
)

export default component.exports